import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { Field, Formik, Form } from "formik";
import { useMutation, useQuery } from "react-query";
import Navbar from "../../Components/Navbar";
import axios from "axios";
import Config from "../../Config";
import MenuItem from "@mui/material/MenuItem";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  BoxSubTitle,
} from "../../Components/Styles/PageStyles";
import {
  SubmitBtn,
  PreviewBtn,
  OtherBtn,
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  CombineInputGroup,
} from "../../Components/Styles/InputStyles";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import moment from "moment";
import Select from "@mui/material/Select";
import { HiUpload } from "react-icons/hi";
import { MdAdd, MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import DropZone from "../../Components/Applications/DropzoneForSignatures";
import { useTranslation } from "react-i18next";

const CorrectionForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openSenderIdModel, setOpenSenderIdModel] = useState(false);
  const [isSendLater, setIsSendLater] = useState(false);
  const [isAffiliated, setIsAffiliated] = useState(false);
  const [isRestricted, setIsRestricted] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [isInterested, setIsInterested] = useState(false);

  const [isSubmitable, setIsSubmitable] = useState(false);

  const [uploadFile, setUploadFile] = useState("");
  const [matrixForm, setMatrixForm] = useState("");
  const [registrarSign, setRegistrarSignature] = useState("");

  const { customerId, bookingId } = useParams();

  const user = useSelector((state) => state?.UserReducer?.user);

  const [customerDetails, setCustomerDetails] = useState({});
  const [isPublished, setIsPublished] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [assocName, setAssocNameLabel] = useState("");
  const [isInitialValueSaved, setIsInitialValueSaved] = useState(true);
  const [previewOpenModel, setPreviewOpenModel] = useState(false);
  const [isReportsent, setIsReportSent] = useState(false);
  const [pdfLink, setPdfLink] = useState("");
  const [reportId, setReportId] = useState("");

  const [isAddDeviceModelOpen, setIsAddDeviceModelOpen] = useState(false);
  const [isBasicFormOpen, setIsBasicFormOpen] = useState(true);
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState(true);
  const [openCreateBookingModel, setOpenCreateBookingModel] = useState(false);

  useEffect(() => {
    if (!previewOpenModel) setIsReportSent(false);
  }, [previewOpenModel]);

  const toggleBasicFormOpen = () => setIsBasicFormOpen(!isBasicFormOpen);

  const toggleReportDetailsOpen = () =>
    setIsReportDetailsOpen(!isReportDetailsOpen);

  // -------------  Initial Data -------------
  // const fetchFunction = async () =>
  //   await axios.get(
  //     `${Config.nodeApiUrl}/getSenderIdContactGroups/sms`,
  //     Config.AxiosConfig
  //   );

  // const {
  //   data,
  //   error,
  //   isLoading: InitialLoading,
  // } = useQuery(`getSenderIdContactGroups`, fetchFunction);

  // -------------   Run Campaign  -------------
  const runCampaignFunction = async (values) =>
  {return await axios.post(`${Config.apiUrl}/correction`, values, {
    headers: { 
      authorization: user.token,
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}

  const onSuccess = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
    
  };

  const onError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: runCampaignLoading, mutate: runCampaignMutate } =
    useMutation(runCampaignFunction, {
      onSuccess: onSuccess,
      onError: onError,
    });

  const InitialValue = {
    assocName: "",
    articleNumber: "",
    reason: "",
    dated: "",
  };

  const SubmitHandler = (values) => {
       if (!values.assocId) {
        return toast.error("Please enter a Association name");
      } else if (!values.articleNumber) {
        return toast.error("Please mention the arcticle to be corrected");
      } else if (!values.reason) {
        return toast.error("Please enter a reason");
      } else if (!values.dated) {
        return toast.error("Please enter the Date");
      } else if (!matrixForm) {
        return toast.error("Please upload the matrix form");
      } else if (!registrarSign) {
        return toast.error("Please upload Registrar's Signature");
      }
      console.log(values);
      const body = new FormData();
      body.append("customerId", user.id);
      body.append("assocId", values.assocId);
      body.append("assocName", assocName);
      // body.append("name", values.name);
      body.append("articleNumber", values.articleNumber);
      body.append("reason", values.reason);
      body.append("dated", values.dated);
      body.append("matrixForm", matrixForm);
      body.append("registrarSign", registrarSign);
      runCampaignMutate(body);
    
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <BoxTitle onClick={() => navigate(-1)}>
            {/* <MdKeyboardArrowLeft className="text-gray-700 w-6 h-6" /> */}
            <p>{t('Correcting_ConstitutionTitle')}</p>
          </BoxTitle>
          <Underline />
          <BoxSubTitle>
          {t('Correcting_ConstitutionSubTitle')}
          </BoxSubTitle>

          <Formik
            initialValues={InitialValue}
            onSubmit={SubmitHandler}
            enableReinitialize={isInitialValueSaved}
          >
            {(formikProps) => (
              <>
                <Form>
                  <FormContainer className="md:mt-8">
                     
                      <>
                      <InputGroup>
                          <Label htmlFor="name">{t('a_name')}</Label>
                          <FieldWrapper $select={true}>
                              <Field
                                required
                                name="name"
                                id="name"
                                autoComplete="off"
                              >
                                {(props) => (

                                <Select
                                {...props.field}
                                  className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                  onChange={(e) => {
                                    const selectedItem = user.associations.find(item => item.id == e.target.value);
                                    console.log(selectedItem.assocName)
                                    setAssocNameLabel (selectedItem.assocName);
                                    // SetDynamicAssociation(e.target.value);
                                    props.form.setFieldValue(
                                      "assocId",
                                      e.target.value
                                    );
                                   
                                  }}
                                >
                                  {user.associations && user.associations.map(item=>(
                                      <MenuItem value={item.id}>{item.assocName}</MenuItem>
                                  ))}
                                  
                                </Select>
                                )}
                              </Field>
                          </FieldWrapper>
                        </InputGroup>

                        
                      
                        {/* <InputGroup>
                          <Label htmlFor="name">Association Name</Label>
                          <FieldWrapper>
                            <Field name="name" id="name" autoComplete="off" />
                          </FieldWrapper>
                        </InputGroup> */}

                        {/* <CombineInputGroup>
                          <InputGroup>
                            <Label htmlFor="contactGroups">
                              Type of Association
                            </Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="contactGroups"
                                id="contactGroups"
                                autoComplete="off"
                              >
                                {(props) => (
                                  <Select
                                    className="w-full h-full"
                                    options={AssociationList}
                                    onChange={(val) =>
                                      props.form.setFieldValue(
                                        "groupId",
                                        val.value
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                          <InputGroup>
                            <Label htmlFor="contactGroups">Choose Region</Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="contactGroups"
                                id="contactGroups"
                                autoComplete="off"
                              >
                                {(props) => (
                                  <Select
                                    className="w-full h-full"
                                    options={RegionList}
                                    onChange={(val) =>
                                      props.form.setFieldValue(
                                        "groupId",
                                        val.value
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                        </CombineInputGroup> */}

                        <InputGroup>
                          <Label htmlFor="articleNumber">
                          {t('CCField2')} 
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="articleNumber"
                              id="articleNumber"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="reason">
                          {t('CCField3')}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="reason"
                              as="textarea"
                              rows="6"
                              id="reason"
                              placeholder={t('Reason')}
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="dated">
                            {t('Dated')}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="dated"
                              id="dated"
                              autoComplete="off"
                              type="date"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="matrixForm">
                           {t('matrix_form')}
                          </Label>
                          <DropZone setUploadFile={setMatrixForm} />
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="registrarsign">
                            {t('Signature')}
                          </Label>
                          <DropZone setUploadFile={setRegistrarSignature} required/>
                        </InputGroup>

                      </>
                  </FormContainer>
              <div className="mt-14">
                  <SubmitBtn type="submit" disabled={runCampaignLoading}>
                          {runCampaignLoading && (
                            <Loading
                              color="white"
                              width={20}
                              height={20}
                              noPadding={true}
                            />
                          )}
                          {!runCampaignLoading && t('Send')}
                        </SubmitBtn>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </BoxContainer>
      </Page>
    </>
  );
};

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-52 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

export default CorrectionForm;
